import classNames from "classnames";
import style from "./Divider.module.scss";

export type DividerProps = {
  orientation?: "horizontal" | "vertical";
  className?: string;
};

export function Divider({
  orientation = "horizontal",
  className,
}: DividerProps) {
  return (
    <div
      className={classNames(style.divider, style[orientation], className)}
      role="separator"
      aria-orientation={orientation}
    />
  );
}
